var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 16.667a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334m0 1.666a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 0 1 0 16.666m0-9.512 2.357-2.357a.833.833 0 1 1 1.179 1.179L11.179 10l2.357 2.357a.833.833 0 1 1-1.179 1.179L10 11.179l-2.357 2.357a.833.833 0 0 1-1.178-1.179L8.822 10 6.465 7.643a.833.833 0 1 1 1.178-1.179z",
    clipRule: "evenodd"
  })));
};
export default SvgCloseCircle;